import PartDropzone from 'components/onboarding/part-dropzone'
import SampleParts from 'components/onboarding/sample-parts'
import UploadedPart from 'components/onboarding/uploaded-part'
import Wrapper from 'components/onboarding/wrapper'
import { useOnboarding } from 'context/onboarding-context'

const ChoosePart = () => {
  const { step, partFile } = useOnboarding()

  return (
    <Wrapper isVisible={step === 2}>
      <section className="flex flex-col gap-3.5">
        <h1 className="flex flex-row flex-wrap items-center gap-1 text-4xl text-gray-300">
          All set! Let’s run your first part:
        </h1>
        {!partFile && (
          <div className="mt-4 flex flex-col items-start gap-2 lg:flex-row">
            <PartDropzone />
            <SampleParts />
          </div>
        )}
        {partFile && <UploadedPart />}
      </section>
    </Wrapper>
  )
}

export default ChoosePart
